import React, { useState } from "react";
import {RegisterBusinessDialog} from 'components/organisms';
import BannerTextImage from "./BannerTextImage";


const HeroSection = ({ data }) => {
    const [registerDialogOpen, setRegisterDialogOpen] = useState(false);
    return (
        <React.Fragment>
            <BannerTextImage title={data?.title}
                subtitle={data?.subTitle}
                button1Label={data?.button1Label}
                button2Label={data?.button2Label}
                backgroundImage={data?.backgroundImage}
                button1Action={() => setRegisterDialogOpen(true)}
                button2Action={() => setRegisterDialogOpen(true)} />
            <RegisterBusinessDialog
                open={registerDialogOpen}
                onClose={() => setRegisterDialogOpen(false)}
            />
        </React.Fragment>

    )
}

export default HeroSection;